export enum menuCustomerViewEnum {
  menu,
  loading,
  expired,
  nonExisting,
  error,
}
